import { ReactElement, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { useWindowSize } from '@Hotels-at-Home/hah-fe-core/dist/hooks';
import { MD_WIDTH } from '@Hotels-at-Home/hah-fe-core/dist/constants';
import HomeStack from '~/ui/pages/Home/common/HomeStack';
import { cart } from '~/constants/siteConfig';
import CommonSwiper from '../../common/CommonSwiper/CommonSwiper';

const BathTowelsRobesSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bathTowelsRobesSection' });
  const { t: tLink } = useTranslation('', {
    keyPrefix: '$local.$homePageLinks.$bathTowelsRobesSection',
  });

  const bathRef = useRef(null);

  const windowSize = useWindowSize();
  const isSmallScreen = Boolean(windowSize.width) && windowSize.width <= MD_WIDTH;
  const { ymalName4 } = cart;

  return (
    <section className="hp-section bath-towels-robes-section" id="hp-bath-towels-robes">
      <div className="bath-towels-robes-section-container">
        <HomeStack
          title={t('heading')}
          description={t('description')}
          img="/images/homePage/bathTowelsRobesSection/pullman-bath-towels-robes.webp"
          imgMobile="/images/homePage/bathTowelsRobesSection/pullman-bath-towels-robes-mob.webp"
          url={tLink('bath-towels-robes-section')}
        />
        <div className="bath-towels-robes-section-content">
          <CommonSwiper
            ymalName={ymalName4}
            isHomepageList
            hasHoverCTA
            ref={bathRef}
            spaceBetween={20}
            breakpoints={{
              960: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 1,
              },
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default BathTowelsRobesSection;
